import { _decorator, Component, Material, Renderer, UIRenderer } from 'cc';
import SharedMaterial from './SharedMaterial';

const { ccclass, executeInEditMode } = _decorator;

@ccclass('BaseShaderManipulator')
@executeInEditMode
export default abstract class BaseShaderManipulator extends Component {
    protected _target: Renderer = null;
    protected _sharedMaterial: SharedMaterial = null;

    protected get target() {
        if (!this._target) {
            this._target = this.findTarget();
            this._sharedMaterial = this.getComponent(SharedMaterial);
        }
        return this._target;
    }

    protected get targetMaterial() {
        if (this._sharedMaterial) {
            return this.target?.sharedMaterial;
        }
        return this.target?.material;
    }

    protected get targetPass() {
        return this.targetMaterial?.passes[0];
    }

    public resetInEditor(): void {
        this.syncProperty();
    }

    protected onEnable() {
        this.registerTargetEvent();
        this.syncProperty();
    }

    protected onDisable() {
        this.unregisterTargetEvent();
    }

    protected findTarget() {
        const target = this.getComponent(Renderer);
        if (!target) {
            throw new Error(`Can't find target component.`);
        }
        return target;
    }

    protected registerTargetEvent(): void {
        this.target.node.on(
            'onMaterialModified',
            (_: number, material: Material) => {
                if (material) {
                    if (this.target instanceof UIRenderer && !this.target.customMaterial) {
                        return;
                    }
                    this.syncProperty();
                }
            },
            this,
        );
    }

    protected unregisterTargetEvent(): void {
        this.target.node.targetOff(this);
    }

    protected abstract syncProperty(): void;
}
